import { Ajax } from '@bamboohr/utils';

export function getCompanyInfo() {
	return Ajax.get('/settings/account/company_info');
}
